(function () {
  const isCollectionPath = (path) => path.startsWith('/collections/');

  // Navigation-Guard (verhindert, dass wir beim echten Klick reinfunken)
  let navigationInProgress = false;
  const markNav = () => {
    navigationInProgress = true;
    window.setTimeout(() => (navigationInProgress = false), 600);
  };

  // Markiere nur echte Navigations-Klicks (Links), nicht jeden Click irgendwo
  document.addEventListener(
    'click',
    (e) => {
      const a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;

      // nur interne Navigation relevant
      const href = a.getAttribute('href') || '';
      if (href.startsWith('#')) return;

      markNav();
    },
    true
  );

  const cleanCollectionURL = () => {
    // nur auf Collections-Seiten arbeiten
    if (!isCollectionPath(window.location.pathname)) return;

    const url = new URL(window.location.href);

    let dirty = false;

    // nur page entfernen (page=1/2/3), andere Querys bleiben (Filter/Sort etc.)
    if (url.searchParams.has('page')) {
      url.searchParams.delete('page');
      dirty = true;
    }

    // hash entfernen
    if (url.hash) {
      url.hash = '';
      dirty = true;
    }

    if (!dirty) return;

    const clean =
      url.origin +
      url.pathname +
      (url.searchParams.toString() ? `?${url.searchParams.toString()}` : '');

    // replaceState nur, wenn wirklich anders
    if (clean !== window.location.href) {
      history.replaceState({}, '', clean);
    }
  };

  // Initial
  window.addEventListener('load', () => {
    cleanCollectionURL();
  });

  // BFCache Restore (sehr oft DER Grund fürs Wohnzimmer-PC Verhalten)
  window.addEventListener('pageshow', () => {
    // pageshow feuert auch bei normalem Load, aber safe
    // Wichtig: nicht blocken, nur kurz verzögern, damit Shopify DOM ready ist
    window.setTimeout(() => {
      if (navigationInProgress) return;
      cleanCollectionURL();
    }, 50);
  });

  // Back/Forward
  window.addEventListener('popstate', () => {
    window.setTimeout(() => {
      if (navigationInProgress) return;
      cleanCollectionURL();
    }, 80);
  });

  // Infinite Scroll / Section Rendering
  let debounceTimer;
  const observer = new MutationObserver(() => {
    if (navigationInProgress) return;
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(cleanCollectionURL, 200);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
